import React, { useEffect, useRef, useState } from "react";
import ReactTypingEffect from "react-typing-effect";
import "./Partner.css";
import PartnerApplyForm from "./auth/Partnerapplyform";
import {
  CheckCircleOutlined,
  TeamOutlined,
  RiseOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const Partner = () => {
  const [activeTab, setActiveTab] = useState("conditions");
  const [showApplyModal, setShowApplyModal] = useState(false);

  const tabs = [
    { key: "conditions", label: "พันธมิตรที่เรามองหา" },
    { key: "benefits", label: "ประโยชน์ที่ได้รับ" },
    { key: "steps", label: "ขั้นตอนการสมัคร" },
  ];

  
  const conditionsRef = useRef(null);
  const benefitsRef = useRef(null);
  const stepsRef = useRef(null);

  const sectionRefs = {
    conditions: conditionsRef,
    benefits: benefitsRef,
    steps: stepsRef,
  };

  const handleTabClick = (key) => {
    setActiveTab(key);
    const target = sectionRefs[key]?.current;
    if (target) {
      
      const offset = 90;
      const top =
        target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  
  useEffect(() => {
    if (!showApplyModal) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") setShowApplyModal(false);
    };
    document.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [showApplyModal]);

  return (
    <div className="partner-page">
      {/* ===== Hero Section ===== */}
      <div className="partner-hero">
        <div className="partner-hero-img-wrap">
          <img
            src={require("../layouts/img/Header2.png")}
            alt="360 Healthy Shop Partner"
            className="partner-hero-img"
          />
        </div>

        <div className="partner-hero-stats">
          <div className="stat-item">
            <span className="stat-num">300,000+</span>
            <span className="stat-label">ฐานลูกค้า</span>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <span className="stat-num">30+</span>
            <span className="stat-label">สาขาทั่วประเทศ</span>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <span className="stat-num">ฟรี GP</span>
            <span className="stat-label">3 เดือนแรก</span>
          </div>
        </div>
      </div>

      {/* ===== Tabs (sticky nav ที่เลื่อนไปหา section) ===== */}
      <div className="partner-tabs-section">
        <div className="partner-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`partner-tab-btn ${
                activeTab === tab.key ? "active" : ""
              }`}
              onClick={() => handleTabClick(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="partner-tab-content">
          {/* พันธมิตรที่เรามองหา */}
          <div className="tab-panel" ref={conditionsRef}>
            <h3 className="tab-panel-title">พันธมิตรที่เรามองหา</h3>
            <div className="partner-cards">
              {[
                {
                  icon: <CheckCircleOutlined />,
                  title: "สินค้า/บริการคุณภาพ",
                  desc: "มีมาตรฐาน ผ่านการรับรอง อย. และ GMP",
                },
                {
                  icon: <RiseOutlined />,
                  title: "พร้อมเติบโต",
                  desc: "ผู้ประกอบการที่มีความพร้อมในการขยายตลาด",
                },
                {
                  icon: <TeamOutlined />,
                  title: "มองระยะยาว",
                  desc: "ธุรกิจที่ต้องการเติบโตอย่างยั่งยืน",
                },
                {
                  icon: <CheckCircleOutlined />,
                  title: "มุ่งมั่นในคุณภาพ",
                  desc: "ส่งมอบสิ่งที่ดีที่สุดให้ลูกค้าเสมอ",
                },
              ].map((item, i) => (
                <div key={i} className="partner-info-card">
                  <div className="partner-info-icon">{item.icon}</div>
                  <h5 className="partner-info-title">{item.title}</h5>
                  <p className="partner-info-desc">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="tab-panel-divider" />

          {/* ประโยชน์ */}
          <div className="tab-panel" ref={benefitsRef}>
            <h3 className="tab-panel-title">ประโยชน์ที่คุณจะได้รับ</h3>
            <p className="tab-panel-intro">
              การเป็นพันธมิตรกับเราไม่ได้หมายถึงแค่การขายสินค้า
              แต่คือการเติบโตไปด้วยกันอย่างยั่งยืน
            </p>
            <div className="benefits-list">
              {[
                {
                  icon: "📣",
                  title: "การโปรโมทแบรนด์",
                  desc: "โปรโมทอย่างมืออาชีพผ่านช่องทางออนไลน์และสาขา",
                },
                {
                  icon: "💰",
                  title: "รายได้ที่เพิ่มขึ้น",
                  desc: "เข้าถึงฐานลูกค้ารักสุขภาพกว่า 300,000 ราย",
                },
                {
                  icon: "🤝",
                  title: "เครือข่ายธุรกิจ",
                  desc: "เชื่อมต่อกับพันธมิตรและผู้เชี่ยวชาญในวงการสุขภาพ",
                },
              ].map((item, i) => (
                <div key={i} className="benefit-row">
                  <span className="benefit-icon">{item.icon}</span>
                  <div>
                    <h5 className="benefit-title">{item.title}</h5>
                    <p className="benefit-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="tab-panel-divider" />

          {/* ขั้นตอน */}
          <div className="tab-panel" ref={stepsRef}>
            <h3 className="tab-panel-title">ขั้นตอนการสมัคร</h3>
            <div className="steps-list">
              {[
                {
                  num: "01",
                  title: "กรอกใบสมัครออนไลน์",
                  desc: "กรอกข้อมูลเกี่ยวกับธุรกิจและสินค้าของคุณในแบบฟอร์มออนไลน์",
                },
                {
                  num: "02",
                  title: "การตรวจสอบและคัดเลือก",
                  desc: "ทีมงานตรวจสอบข้อมูลและติดต่อกลับภายใน 3-5 วันทำการ",
                },
                {
                  num: "03",
                  title: "เซ็นสัญญาและเริ่มต้น",
                  desc: "วางแผนการตลาด การโปรโมท และตั้งค่าต่างๆ ร่วมกัน",
                },
                {
                  num: "04",
                  title: "เปิดตัวสินค้า/บริการ",
                  desc: "เปิดตัวบนแพลตฟอร์มพร้อมแผนการตลาดที่ทรงพลัง",
                },
              ].map((item, i) => (
                <div key={i} className="step-row">
                  <div className="step-num">{item.num}</div>
                  <div className="step-content">
                    <h5 className="step-title">{item.title}</h5>
                    <p className="step-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="partner-cta">
              <h4>สมัครเลยวันนี้!</h4>
              <p>โอกาสสำคัญในการเติบโตทางธุรกิจอยู่ตรงหน้าแล้ว</p>
              <button
                className="btn-partner-apply"
                onClick={() => setShowApplyModal(true)}
              >
                สมัครเป็นพันธมิตรทันที ✦
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Modal สมัคร Partner ===== */}
      {showApplyModal && (
        <div
          className="partner-modal-overlay"
          onClick={() => setShowApplyModal(false)}
        >
          <div
            className="partner-modal-box"
            onClick={(e) => e.stopPropagation()} // กันไม่ให้คลิกข้างในแล้ว modal ปิด
          >
            <button
              className="partner-modal-close"
              onClick={() => setShowApplyModal(false)}
              aria-label="ปิด"
            >
              ✕
            </button>
            <PartnerApplyForm onSuccess={() => setShowApplyModal(false)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Partner;